<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="addCount">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <img v-if="youtube.channelSnippet" class="kit__utils__avatar kit__utils__avatar--rounded kit__utils__avatar--size44 border border-primary d-inline-block" :src="youtube.channelSnippet.thumbnails.medium.url" />
        <img v-else class="kit__utils__avatar kit__utils__avatar--rounded kit__utils__avatar--size44 border border-primary d-inline-block" src="resources/images/avatars/avatar-2.png" />
      </a-badge>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <div v-if="youtube.channelSnippet">
          <strong>{{ youtube.channelSnippet.title }}</strong>
        </div>
        <!-- <div>
          <strong class="mr-1">Billing Plan:</strong> Normal
        </div> -->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div>
          <strong class="mr-1">Email:</strong>
          {{ user.email || '—' }}
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <router-link
          :to="{ name: 'account-info' }"
        >
          <i class="fe fe-user mr-2"></i>
          Account Settings
        </router-link>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>Email Support at support@plannervid.com</a-menu-item>
      <a-menu-item @click="logout">
          <i class="fe fe-log-out mr-2"></i>
          Logout
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user']),
    ...mapState(['youtube']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      count: 0,
    }
  },
  methods: {
    addCount() {
      // this.count++
    },
    logout() {
      this.$store.dispatch('user/LOGOUT')
      this.$gapi.getGapiClient().then((gapi) => {
        const googleAuth = gapi.auth2.getAuthInstance()
        googleAuth.signOut()
      })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
